<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>Received Bill Requests</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">Received Bill Requests</ion-title>
                </ion-toolbar>
            </ion-header>
            <div id="container">
                <ion-segment @ionChange="segmentChanged($event)" :value="billStatus">
                    <ion-segment-button value="pending">
                    <ion-label>Pending</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="">
                    <ion-label>All</ion-label>
                    </ion-segment-button>
                </ion-segment>
                <DataTable :key="billStatus" :loading="loading" :metaKeySelection="false" class="p-datatable-sm" showGridlines :value="bills" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="id" header="ID"></Column>
                    <Column field="user" header="Submited by">
                        <template #body="{data}">
                            {{data.user.name}}
                        </template>
                    </Column>
                    <Column field="bill_type" header="Bill Type"></Column>
                    <Column field="total_amount" header="Total Amount"></Column>
                    <Column field="date" header="Date">
                        <template #body="{data}">
                            {{new Date(data.date).toLocaleDateString()}}
                        </template>
                    </Column>
                    <Column field="status" header="Status"></Column>
                    <Column field="id" header="Action">
                        <template #body="{data}">
                            <ion-button size="small" @click="detailData=data">Details</ion-button>
                        </template>
                    </Column>
                </DataTable>
                <ion-modal :is-open="detailData!=null" @didDismiss="()=>{this.detailData=null}">
                    <ion-page>
                        <ion-header>
                        <ion-toolbar mode="ios">
                            <ion-buttons slot="end">
                            <ion-button @click="detailData=null">Close</ion-button>
                            </ion-buttons>
                            <ion-title>Bill Details</ion-title>
                        </ion-toolbar>
                        </ion-header>
                        <ion-content v-if="detailData!=null" :fullscreen="true">
                            <ion-item>
                                <ion-label>ID</ion-label>
                                <ion-text>
                                    {{detailData.id}}
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Submited By</ion-label>
                                <ion-text>
                                    {{detailData.user.name}}
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Bill Type</ion-label>
                                <ion-text>
                                    {{detailData.bill_type}}
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Total Amount</ion-label>
                                <ion-text>
                                    {{detailData.total_amount}}
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Status</ion-label>
                                <ion-text>
                                    {{detailData.status}}
                                    <div v-for="(ibv,i) of detailData.inhouse_bill_verifications" :key="i">
                                        <strong>{{ibv.submit_to.name}}:</strong> {{ibv.status}}
                                        <small v-if="ibv.status!='pending'">
                                            ({{new Date(ibv.approved_or_declined_at).toLocaleDateString()}}) 
                                            <div v-if="ibv.status=='declined'">
                                            Msg: {{ibv.decline_reason}}
                                            </div>
                                        </small>
                                    </div>
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Date</ion-label>
                                <ion-text>
                                    {{new Date(detailData.date).toLocaleDateString()}}
                                </ion-text>
                            </ion-item>
                            <ion-item v-for="(expense,i) of detailData.inhouse_bill_expenses" :key="i">
                                <div>
                                <h2>
                                    {{expense.expense_head.name}}
                                </h2>
                                    <div v-for="(key,i) of Object.keys(JSON.parse(expense.data))" :key="i">
                                        <strong>{{key}}:</strong> {{JSON.parse(expense.data)[key]}}
                                    </div>
                                    <div>
                                        <strong>Amount:</strong> {{expense.amount}}
                                    </div>
                                    <div v-for="(img,i) of JSON.parse(expense.attachment)" :key="i">
                                        <ion-img :src="host+'inhouse_bill_attachments/'+img">
                                        </ion-img>
                                    </div>
                                </div>
                            </ion-item>
                            <ion-item v-if="detailData.budget_warning" :color="detailData.budget_level=='block' ? 'danger' : 'warning'">
                                <ion-text>
                                    <strong>Budget:</strong> {{detailData.budget_warning}}
                                    <div v-if="detailData.budget_level=='block'"><small>Only an admin can approve this claim.</small></div>
                                </ion-text>
                            </ion-item>
                            <template v-for="(ibv,i) of detailData.inhouse_bill_verifications" :key="i">
                            <ion-item v-if="ibv.submit_to.username.toLowerCase()==username.toLowerCase() && ibv.status=='pending'">
                                <label>
                                    <ion-button @click="approve(detailData.id)" size="small">Approve</ion-button>
                                    <ion-button @click="decline(detailData.id)" size="small" color="warning">Decline</ion-button>
                                </label>
                            </ion-item>
                            </template>
                        </ion-content>
                    </ion-page>
                </ion-modal>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonText, IonItem, IonToolbar, IonButton, IonModal, IonLabel, IonImg, alertController, IonSegment, IonSegmentButton } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { host } from '../config';

export default defineComponent({
  name: 'Received Bill Requests',
  data(){
      return {
          host,
          bills:[],
          detailData:null,
          loading:false,
          perPage:20,
          total:0,
          username:"",
          billStatus:"?type=pending"
      }
  },
  props:[
      'billId'
  ],
  mounted(){
      this.loadData(0);
      this.username=window.localStorage.username;
  },
  methods:{
      segmentChanged(event){
        this.billStatus = event.target.value;
        this.loadData(0);
        //   console.log();
      },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
              'type':this.billStatus
          };
          this.loading=true;
        this.$http.post('myBillRequests',data).then(response=>{
            // const rows=[];
            this.perPage=response.data.per_page;
            this.total=response.data.total;
            this.bills=response.data.data;
            this.loading=false;
            for(const bill of this.bills){
                if(bill.id==this.billId){
                    this.detailData=bill;
                    break;
                }
            }
        });

      },
      onPage(event){
          this.loadData(event.page);
      },
      transfer(){
          if(this.selectedDevices.length==0){
            this.presentAlert("No device seleted!");
            return;
          }
          const serials=[];
          for(const d of this.selectedDevices){
              serials.push(d.serial);
          }
          this.$router.push('/gps-device-transfer/'+JSON.stringify(serials));
      },
       async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    approve(id){
          this.presentConfirmationAlert(async ()=>{
              const data={
                'id':id,
                'username':window.localStorage.username,
                'password':window.localStorage.password,
              };
              this.$http.post('approveBillRequest',data).then(response=>{
                  if(response.data.status){
                      this.detailData=response.data.data;
                      for(const i in this.bills){
                          if(this.bills[i].id==this.detailData.id){
                              this.bills[i]=this.detailData;
                              break;
                          }
                      }
                      this.presentResponseAlert('Success',response.data.msg);
                  }
              });
          });
      },
      decline(id){
        //   console.log(id);
          this.presentDeclineAlert(async alertData=>{
              if(alertData.reason!=null){
                  const data={
                    'id':id,
                    'decline_message':alertData.reason,
                    'username':window.localStorage.username,
                    'password':window.localStorage.password,
                };
                this.$http.post('declineBillRequest',data).then(response=>{
                    if(response.data.status){
                        this.detailData=response.data.data;
                        for(const i in this.bills){
                            if(this.bills[i].id==this.detailData.id){
                                this.bills[i]=this.detailData;
                                break;
                            }
                        }
                        this.presentResponseAlert('Success',response.data.msg);
                    }
                });
              }
          });
      },
    async presentConfirmationAlert(todo) {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Alert',
          message: 'Do you really want to approve this transfer.',
          buttons: [
            {
                text: "No",
                role: 'cancel',
            },
            {
                text: 'Yes',
                role: 'yes',
                handler: todo,
            }
          ],
        });
      await alert.present();
    },
    async presentDeclineAlert(todo) {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          message: 'Why you want to decline this bill request?',
          inputs:[
              {
                  type:'textarea',
                  label:'Reason',
                  name:'reason'
              }
          ],
          buttons: [
            {
                text: "Cancel",
                role: 'cancel',
            },
            {
                text: 'Proceed',
                role: 'yes',
                handler: todo,
            }
          ],
        });
      await alert.present();
    },
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    DataTable,
    Column,
    IonText,
    IonItem,
    IonModal,
    IonLabel,
    IonImg,
    IonSegment, 
    IonSegmentButton
  }
});
</script>

<style>
/* .dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
} */
</style>